export const TKR = {
  name: '创氪智云',
  name_en: 'TrainKr Cloud',
  company: 'TrainKr',
  logo_cn: 'logo_full',
  isTrainkr: true,
  favicon: '/favicon.ico',
  domains: ['trainkr.cloud'],
}

export const LX = {
  name: '思言AI智能平台',
  name_en: '',
  company: 'lingxiai',
  logo_cn: 'lx-logo',
  favicon: '/favicon.lx.ico',
  domains: ['lingxiai.info'],
}

export const GXJY = {
  name: '国信钧元智能云',
  name_en: '',
  company: 'gxjydata',
  logo_cn: 'gxjy-logo',
  favicon: '/favicon.gxjy.ico',
  domains: ['gxjydata.com'],
}

export const LTC = {
  name: '联泰算力云',
  name_en: 'LTAIS',
  company: 'liantai',
  logo_cn: 'liantai-logo',
  logo_full_cn: 'liantai-logo-full',
  favicon: '/favicon.ltc.ico',
  domains: ['ltais.trainkr.cloud', 'lthpc.atcloud.xyz'],
}

export const HAMI = {
  name: '哈密伊吾融合算力云',
  name_en: 'LTAIS',
  company: 'liantai',
  logo_cn: 'hami-logo',
  favicon: '/favicon.hami.ico',
  domains: ['hm.atcloud.xyz'],
}

export const BlankSite = {
  name: '',
  name_en: '',
  company: '',
  logo_cn: '',
  isTrainkr: false,
  favicon: '',
  domains: [],
}

export const BUAA = {
  name: '临舟智算',
  name_en: 'Lin Zhou AIDC',
  company: 'linzhou',
  logo_cn: 'linzhou-logo',
  favicon: '/favicon.ico',
  domains: ['buaa.trainkr.cloud', 'linzhoukeji.com'],
  show_name: true,
}

export const PPIO = {
  name: '算力平台',
  name_en: 'PPIO',
  company: 'PPIO',
  logo_cn: '',
  favicon: '/favicon.ico',
  domains: ['pp.trainkr.cloud'],
  show_name: true,
}


export const AIP = {
  name: '大模型智算平台',
  name_en: '',
  company: '',
  logo_cn: '',
  favicon: '/favicon.ico',
  domains: ['aip.trainkr.cloud'],
  show_name: true,
}

export const SITES = [HAMI, LX, GXJY, LTC, BUAA, PPIO, AIP]
